export default __webpack_public_path__ + "static/media/services-inactive.59d5aefb.svg";